export default "__VITE_ASSET__BHNNGa0s__"